import { useAtomValue } from 'jotai';

import { useCurrentUser, useUserByProfileId } from '@bizzabo/entities';

import VideoNotificationWrapper from '../VideoNotificationWrapper';
import { eventIdAtom, IncomingNotification } from '../atoms';

interface NotificationProps {
    incomingNotification: IncomingNotification;
}

const Notification: React.FC<NotificationProps> = ({ incomingNotification }) => {
    const eventId = useAtomValue(eventIdAtom);
    const { data: currentUser } = useCurrentUser(eventId);
    const { data: callerUser, isLoading } = useUserByProfileId({
        eventId,
        userProfileId: incomingNotification.callerUserProfileId,
    });

    if (isLoading) {
        return null;
    }

    return (
        <VideoNotificationWrapper
            currentUser={currentUser}
            callerUser={callerUser}
            incomingNotification={incomingNotification}
        />
    );
};

export default Notification;
